import React, { Component, KeyboardEvent } from "react";
import Strings from "@my-dld/assets/strings";
import SimpleModal from "@my-dld/components/SimpleModal";
import { AppConstants } from "../../../configApp";
import { ILoginComponent, LoginType } from "./index";
import { ServerDate, StringUtil } from "@eres/core";
import { ILoader } from "../index";
import { Entities, IdentityApi } from "@10x/dubai-rest-api";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { dispatch } from "@my-dld/utils/StoreUtils";
import { SavedLoginAction } from "@my-dld/actions";
import EIDInputConverter from "@my-dld/components/Form/Converters/EidConverter";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { EidInputClassProvider } from "@my-dld/components/FixedEidInput";
import { getAppServices } from "@10x/coreapp";
import DateInputField from "@eres/forms-web/DateInputField";
import StateHolder from "@eres/forms/StateHolder";
import { ErrorContainer } from "@eres/forms";
import { showErrorMessage } from "@my-dld/utils/UIUtils";

interface State {
	eid?: string;
	dob?: ServerDate;
	errorContainer: ErrorContainer;
}

export function EidStateFormatter( eid: string ) {
	return eid.replace( /\D/g, "" );
}

export class EIDLogin extends Component<any, State> implements ILoginComponent<any, State> {
	today = new Date();

	constructor( props: any ) {
		super( props );
		const savedEid = getAppServices().storeService.getStore().getState().User?.savedLogin?.ownerEid;
		this.state = {
			errorContainer: {},
			eid: savedEid ? savedEid : window.setOTP ? "784196310505498" : "784", //"784"
		};
	}


	render() {
		const ds = StateHolder.buildStateHolder( this );
		return (
			<>
				<TextInputField
					containerClassName={ "form-group" }
					inputClassName={ "form-control" }
					placeHolder={ "784-XXXX-XXXXXX-X" }
					id={ "eid" }
					required={ true }
					holder={ this }
					error={ this.state.errorContainer?.eid }
					label={ Strings.emirates_id_number }
					maxLength={ 15 }
					inputProps={ { onKeyPress: this.onKeyUp } }
					converter={ EIDInputConverter }
					inputClassProvider={ EidInputClassProvider }
				>
					<a
						data-bs-target="#emiratesIDInfoModal" data-bs-toggle="modal"
						href="#" className={ "login-input-info" }>
						<span className="sr-only">Information Icon</span>
						<span className="fa fa-info-circle info-icon-input"/></a>
				</TextInputField>
				<DateInputField
					containerClassName={ "field-style form-group-icon" }
					required={ true }
					holder={ ds }
					label={ Strings.date_of_birth }
					id={ "dob" }
					extraOpts={ {
						maxDate: this.today,
						yearRange: "-100:+0"
					} }
				/>
			</>
		);
	}

	onKeyUp = ( event: KeyboardEvent<any> ) => {
		if ( event.charCode === 13 ) {
			this.props.doLogin();
		}
	};

	doLogin = ( loader: ILoader ) => {
		loader.setLoading( true );
		let isValid = true;
		const errorContainer: ErrorContainer = {};
		if ( StringUtil.isEmptyStringOrNull( this.state.eid ) ) {
			errorContainer[ "eid" ] = Strings.please_enter_valid_eid;
			isValid = false;
		}
		if ( isValid ) {
			if ( this.state.eid?.length !== 15 ) {
				errorContainer[ "eid" ] = Strings.please_enter_valid_eid;
				isValid = false;
			}
		}
		if ( StringUtil.isEmptyStringOrNull( this.state.dob ) ) {
			errorContainer[ "dob" ] = Strings.please_enter_dob;
			isValid = false;
		}
		this.setState( { errorContainer: errorContainer } );
		if ( isValid ) {
			dispatch( SavedLoginAction.SAVE_OWNER_EID, this.state.eid );
			trackEventWithData( "Login", "TryLogin", { method: "EmiratesId", id: this.state.eid! } );
			return IdentityApi.loginByEID( this.state.eid!, this.state.dob! )
			.then( Entities.validateResponse )
			.then( profile => {
				loader.setLoading( false );
				return {
					result: profile,
					method: "EmiratesId" as LoginType,
					id: this.state.eid!,
					dob: this.state.dob!
				};
			} )
			.catch( e => {
				loader.setLoading( false );
				if ( canRecover( e ) ) {
					return Promise.reject( {
						recover: true,
						id: this.state.eid!,
					} );
				} else {
					showErrorMessage( e );
					return Promise.reject();
				}
			} );
		}
		loader.setLoading( false );
		return Promise.reject();
	};
}

function canRecover( errors: string ): boolean {

	return errors != null && errors.endsWith( "NEED_UPDATE_MOBILE" );
}

export class EIDModal extends Component<any, any> {
	render() {
		return (
			<SimpleModal id={ "emiratesIDInfoModal" }>
				<img
					alt={ "" }
					className="mb-3 full-width" title="Emirates ID Information"
					src={ `${ AppConstants.rootUrl }/assets/img/emirates-id-ss.png` }/>
				<span><strong>{ Strings.eid_number }</strong></span>
				<p className="mt-2">{ Strings.eid_help }</p>

			</SimpleModal>
		);
	}
}
